module.exports = __webpack_public_path__ + "static/img/tenders_issued.4f2349d6.png";